import styled from 'styled-components';
import { rem } from 'polished';
import { HeadingBlock } from '@whitelabel/component-library';
import { fontSize, fontFamily, lineHeight } from '@whitelabel/helpers/style/type';
import { mediaBreakpointDown, mediaBreakpointUp } from '@whitelabel/helpers/style/grid';
import { spacer, multiply } from '@whitelabel/helpers/style/units';

const StyledHeadingBlock = styled(HeadingBlock)`
  && {
    h1 {
      line-height: ${lineHeight('sm')};
      ${mediaBreakpointUp('lg')`
      margin-bottom: ${multiply(spacer, 1.5)};
    `}
    }
    span {
      display: inline-block;
    }
    .lead {
      font-family: ${fontFamily('serif')};
      max-width: ${rem(665)};
      ${mediaBreakpointDown('sm')`
      font-size: ${fontSize('base')};
    `}
    }
  }
`;

export default StyledHeadingBlock;
